import React, { useEffect } from 'react'
import { CardText, CardBody,
  CardTitle, Container, Row, Col, FormGroup, Label, Input, PopoverBody, UncontrolledPopover } from 'reactstrap'
import ButtonNextWithLine from './ButtonNextWithLine'
import ButtonPrevWithLine from './ButtonPrevWithLine'
import RangeSlider from './RangeSlider'
import ButtonNext from './ButtonNext'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import ButtonPrev from './ButtonPrev'

gsap.registerPlugin(CustomEase)

const qMark = '/assets/question-mark.svg'
const hat = '/assets/animation_graphics/hat.svg'
const book = '/assets/animation_graphics/book.svg'
const pageleft = '/assets/animation_graphics/page-left.svg'
const pageright = '/assets/animation_graphics/page-right.svg'

function Slide6 ({ isActive, onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, annualCostOfEducation, numOfChildren, set, yearsToProvide }) {
  const onPrevClick = () => {
    onDecrementProgress()
    onPrevRequested()
  }

  const onNextClick = () => {
    onIncrementProgress()
    onNextRequested()
  }

  const _handleInputChange = e => {
    set('yearsToProvide', parseFloat(e.target.value))
  }
  useEffect(() => {
    if (isActive) {
      const tl = gsap.timeline({ delay: 2 })
      const ease = CustomEase.create('custom', 'M0,0 C0,0 0.08318,0.2664 0.14193,0.43905 0.18286,0.55934 0.20602,0.62375 0.25214,0.74102 0.28228,0.81765 0.30017,0.86241 0.33637,0.93344 0.3573,0.97452 0.37697,1.00924 0.40222,1.0355 0.41087,1.0445 0.4313,1.04891 0.44292,1.04424 0.47803,1.03013 0.50891,0.9985 0.549,0.97651 0.56111,0.96986 0.5734,0.96353 0.58554,0.96601 0.64121,0.97737 0.69575,1.01266 0.75196,1.01793 0.78272,1.02082 0.81262,0.99138 0.84322,0.99016 0.86491,0.98929 0.88642,1.0117 0.90731,1.01173 0.92467,1.01175 0.94141,0.99256 0.95928,0.9903 0.97259,0.98862 1,1 1,1')

      tl.from('.book', { alpha: 0, duration: 0.1 })
      tl.from('.book', { transformOrigin: 'center', scaleX: 0.1, ease, duration: 0.5 }, '-=.1')
      tl.from('.page-left', { alpha: 0, duration: 0.1 })
      tl.from('.page-left', { x: -10, ease, duration: 0.5 }, '-=.1')
      tl.from('.page-right', { alpha: 0, duration: 0.1 }, '-=.5')
      tl.from('.page-right', { x: 10, ease, duration: 0.5 }, '-=.5')
      tl.from('.hat', { y: -1000, ease, duration: 0.5 }, '-=.4')

      tl.timeScale('1.1')
    }
  }, [isActive])
  return (
    <CardBody className='app-slide Slide6 w-100'>
      <Container fluid>
        <Row>

          <Col xs={{ size: 12 }} xl={{ size: 7 }} className='d-flex'>
            <div className='d-flex align-items-center flex-wrap align-items-center mt-4 pt-2 flex-column flex-xl-row'>
              <div className='graphic-wrapper'>
                <div className='animation-wrapper'>
                  <img className='animated-graphic hat' src={hat} alt='' />
                  <img className='animated-graphic book' src={book} alt='' />
                  <img className='animated-graphic page-left' src={pageleft} alt='' />
                  <img className='animated-graphic page-right' src={pageright} alt='' />
                </div>
              </div>

              <div className='ml-1 pl-xl-1 ml-xl-5 mr-xl-5'>

                <CardTitle className='pb-xl-2 pt-2'>
                  <h2>“Education is not the learning of facts, but the training of the mind to think”</h2>
                  <h3 className='mt-1'>- Albert Einstein</h3>
                </CardTitle>

                <CardText className='pb-xl-2'>
                  Do you want to pay for your child’s college? Tell us the annual cost of education per year, the number of children you have, and how many years of college you would like to pay for.
                  <img alt='question mark' id='qmark' src={qMark} className='qmark hand-cursor' />
                  <UncontrolledPopover className='Slide6-popover' hideArrow placement='auto' target='qmark' trigger='legacy' >
                    <PopoverBody className='Slide6-popover-body'>
                    Visit <a href='https://nces.ed.gov' target='blank'>National Center for Education Statistics</a> to learn more about your options for college tuition, fees and estimated student expenses.
                    </PopoverBody>
                  </UncontrolledPopover>
                </CardText>
              </div>

            </div>
            <ButtonPrevWithLine className='d-none d-xl-block' onClick={onPrevClick} />
          </Col>

          <Col xs={12} xl={4} className='d-flex flex-column align-items-center justify-content-center pr-xl-5 pt-xl-5 mt-5'>

            <h4 className='h4-slider-label'>ANNUAL COST OF EDUCATION</h4>

            <RangeSlider
              minValue={0}
              maxValue={60000}
              step={1000}
              updateRange={set}
              valueKey='annualCostOfEducation'
              value={annualCostOfEducation}
              formatLabel={(value) => `${numeral(value).format('$0,000')}`}
              className='ml-3 mr-xl-3 mb-5' />

            <h4 className='pt-5 h4-slider-label'>CHILDREN</h4>

            <RangeSlider
              minValue={0}
              maxValue={10}
              updateRange={set}
              valueKey='numOfChildren'
              value={numOfChildren}
              className='ml-3 mr-xl-3 mb-5' />

            <FormGroup className='mt-xs-4 d-flex align-items-center justify-content-between mt-3 '>
              <Label className='d-block m0 h4-slider-label h4-slider-label--input mr-4' for='yearsToProvide'>YEARS TO PROVIDE</Label>
              <Input type='number' name='yearsToProvide' id='yearsToProvide' onChange={_handleInputChange} value={yearsToProvide} />
            </FormGroup>

          </Col>
          <Col xl={1} className='d-none d-xl-block'>
            <ButtonNextWithLine onClick={onNextClick} />
          </Col>
          <Col xs={12} className='d-flex justify-content-between d-xl-none mt-xs-4'>
            <ButtonPrev className='ml-3' onClick={onPrevClick} />
            <ButtonNext className='mr-3' onClick={onNextClick} />
          </Col>
        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state) => ({
  annualCostOfEducation: state.app.annualCostOfEducation,
  numOfChildren: state.app.numOfChildren,
  yearsToProvide: state.app.yearsToProvide
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide6)
